import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "templates",
  "use": "templates-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"templates\"><path fill-rule=\"evenodd\" d=\"M6.5 9V5h-4v4h4Zm0 5v-4h-4v4h4Zm5 0v-4h-4v4h4Zm5 0v-4h-4v4h4Zm-5-5V5h-4v4h4Zm1 0h4V5h-4v4Zm9 5v-4h-4v4h4Zm-15 5v-4h-4v4h4Zm5 0v-4h-4v4h4Zm5 0v-4h-4v4h4Zm5 0v-4h-4v4h4Zm-4-10h4V5h-4v4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol